import React from 'react'

const ProjectType = ({ project }) =>
  <div className={`h6 text-uppercase text-${project.type}`}>
    {project.type.split('-').map(word =>
      word[0].toUpperCase() + word.slice(1)
    ).join(' ')}
  </div>

export default ProjectType
